<div class="my-image--gallery">
  <ngx-gallery *ngIf="this.images.length && !isLoading" [options]="this.options" [images]="this.images"></ngx-gallery>
  <app-image-placeholder *ngIf="isLoading"></app-image-placeholder>
</div>
